var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-layout',[_c('div',{staticClass:"page-header"},[_c('h4',[_vm._v("Relatório de Cliques")])]),_c('q-page',{attrs:{"padding":""}},[_c('header-click-reports'),_c('list-click-reports')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }